// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"0a545a4e","163":"e1e0f529","185":"656ba113","236":"8f216235","430":"baba20d5","499":"151aa992","520":"a7376c1d","637":"8a853630","691":"28463664","763":"c6258cd9","821":"28463664"}[chunkId] + ".chunk.css";
};